import React from 'react';

import {default as ExifOrientationImage} from 'react-exif-orientation-img';

const ExifOrientationImg = ({className, src, onClick}: any) => (
  <ExifOrientationImage className={className} src={src} onClick={onClick} />
);

export default ExifOrientationImg;
